/**
 * Lazy Loading Fallback Component
 * Provides a consistent loading experience during code splitting
 */
import { ReactElement } from 'react'

interface LazyLoadingFallbackProps {
  /** Optional message to display during loading */
  message?: string
  /** Whether to show a minimal spinner */
  minimal?: boolean
}

const LazyLoadingFallback = ({
  message = 'ページを読み込んでいます...',
  minimal = false,
}: LazyLoadingFallbackProps): ReactElement => {
  if (minimal) {
    return (
      <div className='flex justify-center items-center py-8'>
        <div className='w-8 h-8 border-2 border-t-ut-primary border-gray-300 rounded-full animate-spin'></div>
      </div>
    )
  }

  return (
    <div className='flex flex-col items-center justify-center min-h-[200px] p-8'>
      {/* UT Branded Spinner */}
      <div className='relative mb-4'>
        <div className='w-12 h-12 border-4 border-t-ut-primary border-gray-200 rounded-full animate-spin'></div>
        {/* Inner dot for better visual appeal */}
        <div className='absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-2 h-2 bg-ut-primary rounded-full'></div>
      </div>

      {/* Loading message */}
      <p className='text-gray-600 text-sm font-medium tracking-wide'>
        {message}
      </p>

      {/* Progress bar effect */}
      <div className='mt-4 w-32 h-1 bg-gray-200 rounded-full overflow-hidden'>
        <div className='h-full bg-ut-primary rounded-full animate-pulse'></div>
      </div>
    </div>
  )
}

export default LazyLoadingFallback
